import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Scrollbars } from 'react-custom-scrollbars';
import { Row, Col, Form, Input, message, Select, Radio, Drawer, Space, Spin } from 'antd';
import ConfirmationPopup from './ConfirmationPopup'
import AllCancelPopup from './AllCancelPopup'
import DeleteConnectionPopup from './DeleteConnectionPopup';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import InitialData from '../Pages/InitialData.json'
import { getCountryData, FecthTableNames, getSeniorityLevelData } from '../../../Api/Services/CommonApiService';
import { getByAddStaffRoleId, deleteAddStaffRole, createAddStaffRole, updateAddStaffRole } from '../../../Api/Services/StaffRoleApiService';
import { AddUser } from '../style';
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { RelatedDocUpload } from '../Pages/GlobalComponents/RelatedDocUpload'
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import Heading from '../../../components/heading/heading';
import { getQueryFieldsByType } from '../../../Api/Services/ViewApiService';
import { convertCurrency, ExchangeCurrency, DateforQueryBuilder } from '../Filters/FilterConditions';
// import Heading from '../../../components/heading/heading';
import { Button } from '../../../components/buttons/buttons';
import { CancelIcon, EditIcon } from '../../../components/Icons/Icons';
import QueryBuilderFunction from '../QueryBuilderComp/QueryBuilderFile'
import { validateShortText } from '../../../components/utilities/utilities';

const { Option } = Select;

const Popup = ({ augRole, handleNavigation, GetAll, activeKey, typeOfAction, jobRoleId, drawerFrom, successMessage, typePage }) => {
    const scrollRef = useRef(null);
    const getFieldPopupContainer = (triggerNode) =>
        scrollRef.current?.view ||
        triggerNode.closest('.ant-drawer-content') ||
        triggerNode.closest('.ant-modal-content') ||
        document.body;
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const loadingRef1 = useRef(false);
    const [deleteClick1, setDelteClick1] = useState(false)
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const Role = localData.role
    const companyProfile = localData.company
    const defaultCurrency = localData.currency
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [action, setAction] = useState("Globally")
    const [displayData, setDisplayData] = useState();
    const [edit, setEdit] = useState(false)
    const [leadInitial, setLeadInitial] = useState()
    const [uiLoad, setUiLoad] = useState(false)
    const [content1, setContent1] = React.useState();
    const [viewPopupType, setViewPopupType] = useState()
    const [FILEList, setFileList] = useState([]);
    const [allCountry, setAllCountry] = useState([])
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [queryField, setQueryField] = useState([])
    const [display, setDisplay] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [entityTableMap, setEntityTableMap] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [seniority, setSeniority] = useState([])
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [uiReady, setUiReady] = useState(false)

    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const [group, setGroup] = useState();
    async function getAllTableName() {
        try {
            const data = await FecthTableNames()
            setEntityTableMap(data)
        } catch (error) {
            message.error(error);
        }
    }
    function convertDateFromProfile(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(profile?.timeZone);
        const toTimezone = extractTimezoneName(company?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const currentTimeInProfile = moment.tz(fromTimezone).format("HH:mm");
        const dateWithTime = moment.tz(
            `${dateTime} ${currentTimeInProfile}`,
            "YYYY-MM-DD HH:mm",
            fromTimezone
        );
        const converted = dateWithTime.clone().tz(toTimezone);
        const formattedDate = converted.format("YYYY-MM-DD");
        return formattedDate
    }
    function convertDateFromCompany(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const currentTimeInProfile = moment.tz(fromTimezone).format("HH:mm");
        const dateWithTime = moment.tz(
            `${dateTime} ${currentTimeInProfile}`,
            "YYYY-MM-DD HH:mm",
            fromTimezone
        );
        const converted = dateWithTime.clone().tz(toTimezone);
        const formattedDate = converted.format("YYYY-MM-DD");
        return formattedDate
    }
    const noValueConditions = new Set([
        "IS NOT EMPTY", "IS NOT NULL", "IS EMPTY", "IS NULL",
        "today", "tomorrow", "yesterday",
        "this_week", "next_week", "last_week",
        "this_month", "next_month", "last_month",
        "this_financial_year", "next_financial_year", "last_financial_year",
        "this_quarter", "next_quarter", "last_quarter"
    ]);
    // const isValidEmail = (email) => {
    //     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //     return emailPattern.test(email);
    // };
    // const isValidPhoneNumber = (phoneNumber) => {
    //     const phonePattern = /^[0-9+-]+$/;
    //     return phonePattern.test(phoneNumber);
    // };
    // const isValidWebsite = (website) => {
    //     const websiteRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //     return websiteRegex.test(website);
    // };
    // const fieldsToValidate = ['primary_email', 'secondary_email', 'email', 'mobile', 'assistant_contact_number', 'phone', 'website'];
    // const validateQuery = (query) => {
    //     if (!fieldsToValidate.includes(query.field)) {
    //         return true;
    //     }
    //     if (noValueConditions.has(query.operator)) {
    //         return true;
    //     }
    //     switch (query.field) {
    //         case 'primary_email':
    //         case 'secondary_email':
    //         case 'email':
    //             if (!isValidEmail(query.value)) {
    //                 message.error(`Please enter a valid email address.`);
    //                 return false;
    //             }
    //             break;
    //         case 'mobile':
    //         case 'assistant_contact_number':
    //         case 'phone':
    //             if (!isValidPhoneNumber(query.value)) {
    //                 message.error(`Invalid number.`);
    //                 return false;
    //             }
    //             break;
    //         case 'website':
    //             if (!isValidWebsite(query.value)) {
    //                 message.error(`Please enter a valid website url.`);
    //                 return false;
    //             }
    //             break;
    //         default:
    //             return false;
    //     }
    //     return true;
    // };
    // const validateQueryData = (queryItems) => {
    //     const validateItems = (items) => {
    //         for (let i = 0; i < items.length; i += 1) {
    //             const item = items[i];
    //             if (item.type === "condition") {
    //                 const isValid = validateQuery(item);
    //                 if (!isValid) return false;
    //             } else if (item.type === "group" && Array.isArray(item.items)) {
    //                 const isGroupValid = validateItems(item.items);
    //                 if (!isGroupValid) return false;
    //             }
    //         }
    //         return true;
    //     };
    //     return validateItems(queryItems);
    // };
    function RequiredValidity(queryItems) {
        const validateItems = (items) => {
            for (let i = 0; i < items.length; i += 1) {
                const item = items[i];
                if (item.type === "condition") {
                    if (!item.field || !item.operator) {
                        return { isValid: false, message: "Incomplete query" };
                    }
                    const conditionValue = item.value;
                    const isEmptyValue =
                        conditionValue === undefined ||
                        conditionValue === null ||
                        (typeof conditionValue === 'string' && conditionValue.trim() === '') ||
                        (Array.isArray(conditionValue) && conditionValue.length === 0);
                    if (!noValueConditions.has(item.operator) && isEmptyValue) {
                        return { isValid: false, message: "Incomplete query" };
                    }
                } else if (item.type === "group" && Array.isArray(item.items)) {
                    const result = validateItems(item.items);
                    if (!result.isValid) {
                        return result;
                    }
                }
            }
            return { isValid: true };
        };
        return validateItems(queryItems);
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const convertQueryData = async (data, ConvertRate, CurencyDecimalPlace, setTypeing) => {
        const processItems = async (items) => {
            return Promise.all(
                items.map(async (item) => {
                    const simpleOperators = ["=", "!=", "<", ">"]
                    if (item.type === "condition") {
                        if (item.Currency === 'YES') {
                            if (item.value !== undefined && item.value !== null && item.value !== "") {
                                if (setTypeing === "Submit") {
                                    item.value = normalizeValue(item.value);
                                    const convertedValue = await convertCurrency(ConvertRate, Number(item.value));
                                    item.value = Number(convertedValue);
                                } else if (setTypeing === "Seting") {
                                    const exchangedValue = await ExchangeCurrency(Number(item.value), ConvertRate);
                                    item.value = Number(exchangedValue?.toFixed(CurencyDecimalPlace));
                                }
                            }
                        }
                        if (setTypeing === "Submit") {
                            if (["competition", "contact_person", "followers", "child_case"].includes(item.field)) {
                                item.value = (item.value && item.value.length > 0)
                                    ? item.value.join(',')
                                    : null;
                            }
                            else {
                                item.value = normalizeValue(item.value);
                            }
                            if (item.Key === 'Date') {
                                if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                                    if (simpleOperators.includes(item.operator)) {
                                        item.value = convertDateFromProfile(item.value, companyProfile, profile)
                                    }
                                }
                            }
                        } else if (setTypeing === "Seting") {
                            if (["competition", "contact_person", "followers", "child_case"].includes(item.field)) {
                                item.value = item.value
                                    ? item.value.split(',').map(user => Number(user))
                                    : [];
                            }
                            if (item.Key === 'Date') {
                                if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                                    if (simpleOperators.includes(item.operator)) {
                                        item.value = convertDateFromCompany(item.value, profile, companyProfile)
                                    }
                                }
                            }
                        }
                    } else if (item.type === "group" && Array.isArray(item.items)) {
                        item.items = await processItems(item.items);  // Recursively process sub-items
                    }

                    return item;
                })
            );
        };
        return processItems(data);
    };
    const buildQuery = async (tableName, groupData) => {
        const clausePromises = groupData.items.map(async (item, index) => {
            let clause = "";
            if (item.type === "condition") {
                const isDropDownField = item.Key === "Drop Down";
                const isNumericField = item.Key === "Numbers";
                const isDateField = item.Key === "Date";
                const isBoolean = item.Key === "Boolean";
                const isValidNumber = item.value !== '' && !Number.isNaN(Number(item.value));
                const isDropDownMultiple = item.Key === "Drop Down" && (item.field === "competition" || item.field === "contact_person" || item.field === "followers" || item.field === "child_case");
                if (item.operator === "IS NULL" || item.operator === "IS NOT NULL") {
                    clause = `${tableName}.${item.field} ${item.operator}`;
                }
                else if (isDropDownMultiple && item.operator === "=") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}%'`;
                }
                else if (isDropDownMultiple && item.operator === "!=") {
                    clause = `${tableName}.${item.field} NOT LIKE '%${item.value}%'`;
                }
                else if (item.operator === "contains") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}%'`;
                }
                else if (item.operator === "NOT LIKE") {
                    clause = `${tableName}.${item.field} NOT LIKE '%${item.value}%'`;
                }
                else if (item.operator === "starts_with") {
                    clause = `${tableName}.${item.field} LIKE '${item.value}%'`;
                }
                else if (item.operator === "ends_with") {
                    clause = `${tableName}.${item.field} LIKE '%${item.value}'`;
                }
                else if (isDateField) {
                    if (item.field === "created_at" || item.field === "dealCreatedAt" || item.field === "modified_at") {
                        const supportedViews = ["Lead", "Contact", "Account", "Deal", "Task"];
                        const datefrom = ["today", "yesterday"];
                        if (supportedViews.includes("User")) {
                            const DateOperators = ["=", "!=", "<", ">"];
                            if (DateOperators.includes(item.operator)) {
                                clause = `${tableName}.${item.field} ${item.operator} '${item.value}'`;
                            }
                            else if (datefrom.includes(item.operator)) {
                                clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            }
                            else {
                                clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date}} AND {{${item.operator}_end_date}}`;
                            }
                        } else {
                            const DateOperators = ["=", "!=", "<", ">"];
                            if (DateOperators.includes(item.operator)) {
                                const dates = await DateforQueryBuilder(item.operator, "DatesTime", item.value, companyProfile, profile)
                                clause = `${tableName}.${item.field} BETWEEN '${dates.start}' AND '${dates.end}'`;
                            }
                            // else if (datefrom.includes(item.operator)) {
                            //     clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            // }
                            else {
                                clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date_time}} AND {{${item.operator}_end_date_time}}`;
                            }
                        }
                    }
                    else {
                        const simpleOperators = ["=", "!=", "<", ">", "today", "yesterday", "tomorrow"];
                        const datefrom = ["today", "yesterday", "tomorrow"];
                        if (simpleOperators.includes(item.operator)) {
                            if (datefrom.includes(item.operator)) {
                                clause = `${tableName}.${item.field} = {{${item.operator}}}`;
                            } else {
                                clause = `${tableName}.${item.field} ${item.operator} '${item.value}'`;
                            }
                        } else {
                            clause = `${tableName}.${item.field} BETWEEN {{${item.operator}_start_date}} AND {{${item.operator}_end_date}}`;
                        }
                    }
                }
                else {
                    clause = `${tableName}.${item.field} ${item.operator} ${(isNumericField || isBoolean || (isDropDownField && isValidNumber))
                        ? item.value
                        : `'${item.value}'`
                        }`;

                }
            } else if (item.type === "group") {
                const inner = await buildQuery(tableName, item);
                const conditionCount = item.items.filter(
                    (child) => child.type === "condition"
                ).length;
                const shouldWrap = conditionCount > 1;
                clause = shouldWrap ? `(${inner})` : inner;
                // clause = `(${inner})`;
            }
            if (index > 0 && item.relationWithPrevious) {
                clause = `${item.relationWithPrevious.toUpperCase()} ${clause}`;
            }
            return clause;
        });
        const parts = await Promise.all(clausePromises);
        return parts.join(" ");
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const CloseDrawer = () => {
        setEdit(false)
        setCancelConfirmOpen(false)
        form.setFieldsValue({
            roleName: null,
            perdayRate: null,
            organizationLevel: null,
            // description: null,
            country: null,
        })
        setContent1()
        setAction("Globally")
        setFileList([])
        setGroup()
        setViewPopupType()
        handleNavigation()
    }
    async function setInitialData(value) {
        setLeadInitial({
            roleName: normalizeValue(value.roleName),
            roleFiles: (value.roleFiles || []),
            rolePerDayRate: normalizeValue(value.rolePerDayRate),
            organizationLevel: normalizeValue(value.organizationLevel),
            country: normalizeValue(value.country),
            jobDescription: normalizeValue(value.jobDescription),
            sharedWith: value.sharedWith || "Globally",
            query: value?.query,
            queryBuilder: value?.queryBuilder
        })
    }
    const setDataTostate = async (value) => {
        if (value) {
            const sellingPrice = value.rolePerDayRate
                ? await ExchangeCurrency(Number(value.rolePerDayRate), ConvertRate)
                : value.rolePerDayRate;
            form.setFieldsValue({
                roleName: value.roleName,
                perdayRate: Number(sellingPrice?.toFixed(CurencyDecimalPlace)),
                organizationLevel: value.organizationLevel,
                // description: value.jobDescription,
                country: value.country,
            })
            setContent1(value.jobDescription)
            setFileList(value.roleFiles || [])
            setAction(value.sharedWith || "Globally")
            if (value.sharedWith === "Specific_user") {
                const copiedGroup = JSON.parse(JSON.stringify(value?.query));
                const processedItems = await convertQueryData(copiedGroup.items, ConvertRate, CurencyDecimalPlace, "Seting");
                copiedGroup.items = processedItems;
                setGroup(copiedGroup)
                setViewPopupType("Edit")
            } else {
                setGroup()
                setViewPopupType("Create")
            }
            const updatedPerson = {
                ...value,
                rolePerDayRate: sellingPrice ? Number(sellingPrice?.toFixed(CurencyDecimalPlace)) : sellingPrice,
            };
            setDisplayData(updatedPerson)
        }
    }
    async function getDataApi(value) {
        try {
            const data = await getByAddStaffRoleId(value);
            setDataTostate(data)
            setInitialData(data)
        } catch (error) {
            message.error(error)
        }
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisplay(true)
        let hideMessage;
        if (action === "Specific_user") {
            const validation = RequiredValidity(group?.items);
            if (!validation.isValid) {
                message.error(validation.message);
                loadingRef.current = false;
                setDelteClick(false)
                setDisplay(false)
                return;
            }
        }
        let SaveQuery = "";
        let copiedGroup;
        if (action === "Specific_user") {
            copiedGroup = JSON.parse(JSON.stringify(group));
            const processedItems = await convertQueryData(copiedGroup.items, ConvertRate, CurencyDecimalPlace, "Submit");
            copiedGroup.items = processedItems;
            const tableName = entityTableMap.find(t => t.entityName === "Users")?.tableName || "";
            const finalQuery = await buildQuery(tableName, copiedGroup);
            if (tableName) {
                SaveQuery = `SELECT {{*}} FROM ${tableName} WHERE (${finalQuery})`;
            } else {
                SaveQuery = finalQuery;
            }
        }
        // if (action === "Specific_user") {
        //     if (!validateQueryData(group?.items)) {
        //         setDisplay(false)
        //         return;
        //     }
        // }
        const {
            roleName,
            perdayRate,
            organizationLevel,
            // description,
            country
        } = values;
        const sellingPrice = perdayRate
            ? await convertCurrency(ConvertRate, Number(perdayRate))
            : perdayRate * 1;
        const payload = {
            roleName: normalizeValue(roleName),
            roleFiles: FILEList,
            rolePerDayRate: normalizeValue(sellingPrice),
            organizationLevel: normalizeValue(organizationLevel),
            country: normalizeValue(country),
            jobDescription: normalizeValue(content1),
            sharedWith: normalizeValue((profile.roleName === "Administrator" || (profile.companyRole === "Administrator" ||
                profile.companyRole === "CEO")) ? action : "None"),
            query: action === "Specific_user" ? copiedGroup : null,
            queryBuilder: action === "Specific_user" ? SaveQuery : null,
        }
        const updatedFields = getChangedFields(payload, leadInitial);
        if (Object.keys(updatedFields).length === 0) {
            message.success("StaffRole updated")
            GetAll()
            setDisplay(false)
            setEdit(false)
            CloseDrawer()
            return;
        }
        if (typeOfAction === "Create") {
            try {
                hideMessage = message.loading("Loading...", 0);
                const response = await createAddStaffRole(updatedFields)
                if (response.status === 201) {
                    hideMessage();
                    GetAll()
                    setEdit(false)
                    setDisplay(false)
                    if (response?.data === AutomationMessage) {
                        successMessage("Automation rule triggered", response?.data)
                    } else {
                        message.success(response?.data)
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    CloseDrawer()
                    // if (typeOfPage !== "RolePage") {
                    //     handleRolesChange(roleIndex, 'roleName', response.data.roleNameId)
                    // }
                }
            } catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                hideMessage();
                setDisplay(false)
                message.error(error)
            }
        }
        if (typeOfAction === "Update") {
            try {
                if (updatedFields.queryBuilder && !('sharedWith' in updatedFields)) {
                    updatedFields.sharedWith = normalizeValue((profile.roleName === "Administrator" || (profile.companyRole === "Administrator" ||
                        profile.companyRole === "CEO")) ? action : "None")
                }
                hideMessage = message.loading("Loading...", 0);
                const response = await updateAddStaffRole(updatedFields, jobRoleId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        setConfirmPopup(false)
                        hideMessage();
                        setDisplay(false)
                        loadingRef.current = false;
                        setDelteClick(false)
                    }
                    else {
                        GetAll()
                        setDisplay(false)
                        setEdit(false)
                        hideMessage();
                        if (response.data[0].message === AutomationMessage) {
                            successMessage("Automation rule triggered", response.data[0].message)
                        } else {
                            message.success(
                                <span>
                                    Staff Role <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                </span>
                            );
                        }
                        CloseDrawer()
                        loadingRef.current = false;
                        setDelteClick(false)
                    }
                }
            } catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                setDisplay(false)
                hideMessage();
                message.error(error)
            }
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const getSeniorityLevel = async () => {
        try {
            const data = await getSeniorityLevelData()
            const options = data.map((option, i) => (
                <Option value={option.seniorityLevel} key={i}>
                    {option.seniorityLevel}
                </Option>));
            setSeniority(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleCheckbox = (value) => {
        setAction(value)
        if (value === "Specific_user") {
            if (!group) {
                setViewPopupType("Create")
            }
        }
    }
    const getQueryFields = async () => {
        try {
            const response = await getQueryFieldsByType("Users", "Views")
            if (response.status === 200) {
                setQueryField(response.data)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
    }
    async function deleteMenu(id) {
        if (loadingRef1.current) return;
        loadingRef1.current = true;
        setDelteClick1(true)
        setDisplay(true)
        try {
            const Response = await deleteAddStaffRole(id)
            if (Response.status === 200) {
                if (Array.isArray(Response.data) && Response.data.length > 0 && Response.data[0].entityType !== 'Success') {
                    setErrorData(Response.data);
                    setIsModalVisible(true);
                    setDisplay(false)
                    setConfirmPopup(false)
                    loadingRef1.current = false;
                    setDelteClick1(false)
                } else {
                    GetAll()
                    setEdit(false)
                    setConfirmPopup(false)
                    setDisplay(false)
                    if (Response.data[0].entityMessage === AutomationMessage) {
                        successMessage("Automation rule triggered", Response.data[0].entityMessage)
                    } else {
                        message.success(
                            <span>
                                Staff Role <strong>{Response?.data?.[0]?.entityName}</strong> has been deleted successfully
                            </span>
                        );
                    }
                    loadingRef1.current = false;
                    setDelteClick1(false)
                    // message.success("Job role deleted")
                    CloseDrawer()
                }
            }
        } catch (error) {
            loadingRef1.current = false;
            setDelteClick1(false)
            setDisplay(false)
            message.error(error)
        }
    }
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getCountry(),
            getSeniorityLevel(),
            getQueryFields(),
            getAllTableName()
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (typeOfAction && augRole) {
            fetchAll();
        }
    }, [typeOfAction, augRole]);
    useEffect(() => {
        if (defaultCurrency) {
            if (typeOfAction === "Create") {
                setDisplayData('create')
                form.setFieldsValue({
                    roleName: undefined,
                    perdayRate: undefined,
                    organizationLevel: undefined,
                    // description: undefined,
                    country: undefined,
                })
                setContent1()
                setLeadInitial(InitialData.StaffRoleData)
                setAction(activeKey === "1" ? "None" : "Globally")
                setFileList([])
                setGroup()
                setViewPopupType("Create")
                setEdit(true)
            }
            if (typeOfAction === "Update" && jobRoleId) {
                setDisplayData()
                getDataApi(jobRoleId)
            }
        }
    }, [defaultCurrency, jobRoleId, typeOfAction])
    const PageCancel1 = () => {
        if (edit) {
            setCancelConfirmOpen(true)
        }
        else {
            CloseDrawer()
        }
    }
    const CloseDrawer2 = () => {
        setEdit(false)
        getDataApi(jobRoleId)
    }
    const PageCancel = () => {
        if (typeOfAction === "Update" && jobRoleId) {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        GetAll()
        setConfirmPopup(false)
        setDisplay(false)
        setEdit(false)
        CloseDrawer()
    }

    const handleChange1 = (val) => {
        setContent1(val);
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    typeOfAction === "Update" ?
                        <span>
                            Update Staff Roles
                            {displayData?.roleName && (
                                <>
                                    <span style={{
                                        margin: '0 10px',
                                        color: '#d9d9d9',
                                        fontWeight: 'normal'
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {displayData.roleName}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Add Staff Roles"
                }
                closable={false}
                placement="right"
                open={augRole}
                width="80%"
                extra={
                    < Space >
                        {((drawerFrom !== "Shared" || Role === "Administrator")
                            && typePage !== "Details" && !edit) ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => setEdit(true)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        setEdit(true)
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={(edit && uiReady) ? [<div className="form_action_button">
                    <Button
                        className="gray-button" disabled={display}
                        onClick={() => PageCancel()} size="small"
                    >
                        <FeatherIcon icon="x" />Cancel
                    </Button>
                    {typeOfAction === "Update" &&
                        <Button className="red-button" size="small" onClick={() => OnClickofDelete(jobRoleId)} disabled={display || deleteClick1} loading={deleteClick1}>
                            {!deleteClick1 && <FeatherIcon icon="trash-2" />}Delete
                        </Button>}
                    <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={display || deleteClick} loading={deleteClick}>
                        {!deleteClick && <FeatherIcon icon="save" />} {typeOfAction === "Update" ? "Update" : "Save"}
                    </Button>
                </div>] : false}
            >{(displayData && uiReady) ? <Scrollbars ref={scrollRef} autoHide autoHideTimeout={500} autoHideDuration={200}>
                <Form style={{ width: '100%' }} form={form} name="information" colon={false} onFinish={(values) => onSubmit(values, 'save')} onFinishFailed={onFinishFailed} >
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <VerticalFormStyleWrap>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Heading as="h5">Staff Role Information</Heading>
                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Role Name" name="roleName" id="roleName"
                                                        rules={edit ? [{
                                                            required: true,
                                                            transform: (value) => value?.trim(), message: 'Enter role name',
                                                        }, {
                                                            validator: (_, value) => {
                                                                const error = validateShortText(value, 50);
                                                                if (error) {
                                                                    return Promise.reject(new Error(error));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }] : [{ required: false }]}>
                                                        {edit ? <Input placeholder='Enter Role Name' /> :
                                                            <span>{displayData?.roleName}</span>
                                                        }
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Organization Level" name="organizationLevel" id="organizationLevel">
                                                        {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} placeholder="Select organization level"
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }>
                                                            {seniority}
                                                        </Select> :
                                                            <span>{displayData?.organizationLevel}</span>
                                                        }
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                    <Form.Item label="Work Location" name="country" id="country"
                                                        rules={edit ? [{ required: true, message: 'Select a country', }] : [{ required: false }]}>
                                                        {edit ? <Select
                                                            style={{ width: '100%' }}
                                                            showSearch
                                                            placeholder="Select Country"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                        >
                                                            {allCountry?.map((option) => (
                                                                <Option key={option.countryId} value={option.country}>
                                                                    {option.country}
                                                                </Option>
                                                            ))}
                                                        </Select> :
                                                            <span>{displayData?.country}</span>
                                                        }
                                                    </Form.Item></Col>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label=
                                                        {`Per day Rate (${defaultCurrency && defaultCurrency?.currency})`}
                                                        name="perdayRate" id="perdayRate"
                                                        rules={edit ? [{
                                                            required: true,
                                                            transform: (value) => value?.trim(), message: 'Enter per day rate',
                                                        }, {
                                                            validator: async (_, value) => {
                                                                if (value === undefined || value === null || value === '') {
                                                                    return Promise.resolve();
                                                                }
                                                                if (value?.toString()?.length > 25) {
                                                                    return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                }
                                                                // Strict numeric check (digits with optional 1 dot)
                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                if (!basicNumberCheck.test(value)) {
                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                }

                                                                // Check decimal places (must be ≤ 2)
                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                if (!decimalRegex.test(value)) {
                                                                    return Promise.reject(
                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                    );
                                                                }
                                                            }
                                                        },] : [{ required: false }]}>
                                                        {edit ? <Input placeholder='Enter Per day Rate' min={0} prefix={defaultCurrency && defaultCurrency?.symbol} />
                                                            :
                                                            <>{defaultCurrency?.symbol}<span>
                                                                {displayData?.rolePerDayRate?.toLocaleString()}
                                                            </span>
                                                            </>}</Form.Item>
                                                </Col>
                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Job Description" >
                                                        {/* // name="description" id="description"   rules={edit ?
                                                            //     [
                                                            //         {
                                                            //             validator: (_, value) => {
                                                            //                 const error = validateDescriptionField(value, 2500);
                                                            //                 if (error) {
                                                            //                     return Promise.reject(new Error(error));
                                                            //                 }
                                                            //                 return Promise.resolve();
                                                            //             },
                                                            //         },
                                                            //     ] : [{ required: false }]
                                                            // }> */}
                                                        {edit ? <TinyMCEEditor
                                                            placeholder="Enter Description"
                                                            content={content1}
                                                            setContent={handleChange1}
                                                            edit
                                                            page="TextBoxs"
                                                            height={150}
                                                            selectedEntity="A"
                                                        /> :
                                                            <CustomHtmlParser html={content1} key={1} page="TextBoxs" />}
                                                        {/* {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' />
                                                            : <span>{displayData?.jobDescription}</span>} */}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {(profile.roleName === "Administrator" || (profile.companyRole === "Administrator" ||
                                                profile.companyRole === "CEO")) ?
                                                <>
                                                    <Heading as="h5">Shared With</Heading>
                                                    <Radio.Group value={action} onChange={(e) => handleCheckbox(e.target.value)} style={{ width: '100%' }} disabled={!edit}>
                                                        <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                                            <Col span={1} style={{ marginBottom: 30 }} />
                                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='Globally'>Globally</Radio></Col>
                                                            <Col span={1} style={{ marginBottom: 30 }} />
                                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='Specific_user'>Specific Users</Radio></Col>
                                                            <Col span={1} style={{ marginBottom: 30 }} />
                                                            <Col span={6} style={{ marginBottom: 30 }} ><Radio value='None'>Only me</Radio></Col>
                                                        </Row>
                                                    </Radio.Group>
                                                    {action === "Specific_user" &&
                                                        <>
                                                            {viewPopupType ?
                                                                <div style={{ marginBottom: 20, padding: "0px 15px" }}>
                                                                    <QueryBuilderFunction viewType="User" queryField={queryField} group={group} setGroup={setGroup} setUiLoad={setUiLoad} pageFor={viewPopupType === "Create" ? "New" : "Edit"}
                                                                        pageFrom="ShareQuery" isEditable={edit} uiLoad={uiLoad} />
                                                                </div> : <></>}
                                                        </>
                                                    }
                                                </> : <></>}
                                            <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                        </div>
                                    </div>
                                </VerticalFormStyleWrap>
                            </BasicFormWrapper>
                        </div>
                    </AddUser> </Form>
            </Scrollbars> :
                <div className="spin">
                    <Spin />
                </div>
                }
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="StaffRole" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page="Details" type="StaffRole" getCallBack={getRefreshtheTable} />}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} />}
        </>
    );
};

Popup.propTypes = {
    augRole: PropTypes.bool.isRequired,
    handleNavigation: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    // typeOfPage: PropTypes.string.isRequired,
    typeOfAction: PropTypes.string.isRequired,
    jobRoleId: PropTypes.number.isRequired,
    successMessage: PropTypes.func.isRequired,
    typePage: PropTypes.string,
    drawerFrom: PropTypes.string,
    activeKey: PropTypes.any,
};

export default Popup;